<template>
  <div class="CollectionListHeader inner_center">
    <div class="title">
      <slot name="icon" class="icon" />
      {{ title || topicTitle }}

      <slot name="topicNum"></slot>
    </div>
<!--     :href=" PAGE_PATH.TOPIC.COLLECTION + '/' + item.id "-->
    <a
      :href="moreLink"
      target="_blank"
      class="more">
      查看更多
      <i class="iconfont icon-a-arrowright" />
    </a>
  </div>
</template>

<script>
import { PAGE_PATH } from "@/constant/PAGE_PATH";

export default {
  name: "CollectionListHeader",
  props:{
    // eslint-disable-next-line vue/require-default-prop
    title: {
      type: String,
      default: ""
    },
    topicTitle: {
      type: String,
      default: ""
    },
    moreLink:{
      type: String,
      default: ""
    }
  },
  data(){
    return {
      PAGE_PATH
    }
  }
}
</script>

<style lang="scss" scoped>
.CollectionListHeader{
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 24px;
  .title{
    font-size: 24px;
    font-weight: bold;
    color: #2D2B33;
    line-height: 31px;
    letter-spacing: 2px;
    display: flex;
    align-items: center;
    justify-content: center;

    .icon{
      margin-right: 14px;
    }
  }
  .more{
    font-size: 14px;
    color: #424866;
    line-height: 19px;
    display: flex;
    align-items: center;
    justify-content: center;
    @include ElementHover(#F94D67,'');

    .icon-a-arrowright{
      font-size: 20px;
    }


  }
}
</style>
